import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  toString1pkumu07cwy4m as toString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { cachedSerialNames31jc5fovi62px as cachedSerialNames } from './Platform.common.mjs';
import { SerialDescriptor2pelqekb5ic3a as SerialDescriptor } from '../descriptors/SerialDescriptor.mjs';
import { CachedNames2minxlyafeo07 as CachedNames } from './CachedNames.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var NullableSerializerClass;
function NullableSerializer() {
  if (NullableSerializerClass === VOID) {
    class $ {
      constructor(serializer) {
        this.o1z_1 = serializer;
        this.p1z_1 = new (SerialDescriptorForNullable())(this.o1z_1.h1m());
      }
      h1m() {
        return this.p1z_1;
      }
      q1z(encoder, value) {
        if (!(value == null)) {
          encoder.u1s();
          encoder.r1s(this.o1z_1, value);
        } else {
          encoder.u1r();
        }
      }
      i1m(encoder, value) {
        return this.q1z(encoder, value);
      }
      j1m(decoder) {
        return decoder.j1q() ? decoder.x1q(this.o1z_1) : decoder.k1q();
      }
      equals(other) {
        if (this === other)
          return true;
        if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
          return false;
        if (!(other instanceof NullableSerializer()))
          THROW_CCE();
        if (!equals(this.o1z_1, other.o1z_1))
          return false;
        return true;
      }
      hashCode() {
        return hashCode(this.o1z_1);
      }
    }
    initMetadataForClass($, 'NullableSerializer', VOID, VOID, [KSerializer()]);
    NullableSerializerClass = $;
  }
  return NullableSerializerClass;
}
var SerialDescriptorForNullableClass;
function SerialDescriptorForNullable() {
  if (SerialDescriptorForNullableClass === VOID) {
    class $ {
      constructor(original) {
        this.x1o_1 = original;
        this.y1o_1 = this.x1o_1.k1n() + '?';
        this.z1o_1 = cachedSerialNames(this.x1o_1);
      }
      k1n() {
        return this.y1o_1;
      }
      h1q() {
        return this.z1o_1;
      }
      w1o() {
        return true;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SerialDescriptorForNullable()))
          return false;
        if (!equals(this.x1o_1, other.x1o_1))
          return false;
        return true;
      }
      toString() {
        return toString(this.x1o_1) + '?';
      }
      hashCode() {
        return imul(hashCode(this.x1o_1), 31);
      }
      d1p() {
        return this.x1o_1.d1p();
      }
      e1p() {
        return this.x1o_1.e1p();
      }
      f1p() {
        return this.x1o_1.f1p();
      }
      g1p() {
        return this.x1o_1.g1p();
      }
      h1p(index) {
        return this.x1o_1.h1p(index);
      }
      i1p(name) {
        return this.x1o_1.i1p(name);
      }
      j1p(index) {
        return this.x1o_1.j1p(index);
      }
      k1p(index) {
        return this.x1o_1.k1p(index);
      }
      l1p(index) {
        return this.x1o_1.l1p(index);
      }
    }
    initMetadataForClass($, 'SerialDescriptorForNullable', VOID, VOID, [SerialDescriptor(), CachedNames()]);
    SerialDescriptorForNullableClass = $;
  }
  return SerialDescriptorForNullableClass;
}
//region block: exports
export {
  NullableSerializer as NullableSerializer41etqlj0tdq5,
  SerialDescriptorForNullable as SerialDescriptorForNullable2slcv65za9oog,
};
//endregion

//# sourceMappingURL=NullableSerializer.mjs.map
